export default __webpack_public_path__ + "static/media/09AW2DEC65.91af14df.jpg";